/* ============================================================
   TAYLORGANG PREMIUM THEME — Core JavaScript
   ============================================================ */

(function() {
  'use strict';

  /* --- Header scroll effect --- */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }, { passive: true });
  }

  /* --- Mobile menu toggle --- */
  var menuToggle = document.querySelector('.header__menu-toggle');
  // Support both centered (.header__mobile-nav) and default (.header__nav) layouts
  var mobileNav = document.querySelector('.header__mobile-nav') || document.querySelector('.header__nav');

  function isMobile() {
    return window.innerWidth <= 960;
  }

  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function() {
      var isActive = mobileNav.classList.toggle('active');
      this.classList.toggle('active');
      this.setAttribute('aria-expanded', isActive);
      document.body.style.overflow = isActive ? 'hidden' : '';
    });

    // Close button inside mobile nav
    var mobileClose = document.querySelector('[data-mobile-close]');
    if (mobileClose) {
      mobileClose.addEventListener('click', function() {
        mobileNav.classList.remove('active');
        menuToggle.classList.remove('active');
        menuToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    }

    // Dropdown toggles — responsive to breakpoint changes
    document.querySelectorAll('.header__dropdown').forEach(function(dropdown) {
      var link = dropdown.querySelector('.header__nav-link');
      if (link) {
        link.addEventListener('click', function(e) {
          if (isMobile() && dropdown.querySelector('.header__dropdown-menu')) {
            e.preventDefault();
            dropdown.classList.toggle('active');
          }
        });
      }
    });
  }

  /* --- Cart Drawer --- */
  var cartDrawer = document.querySelector('.cart-drawer');
  var cartOverlay = document.querySelector('.cart-drawer__overlay');
  var cartClose = document.querySelector('.cart-drawer__close');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('active');
    if (cartOverlay) cartOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('active');
    if (cartOverlay) cartOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-cart-toggle]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      openCart();
    });
  });

  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeCart();
      closeSearch();
    }
  });

  /* --- Search Overlay --- */
  var searchOverlay = document.querySelector('.search-overlay');
  var searchCloseBtn = document.querySelector('.search-overlay__close');
  var searchInput = document.querySelector('.search-overlay__input');

  function openSearch() {
    if (searchOverlay) {
      searchOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      if (searchInput) setTimeout(function() { searchInput.focus(); }, 300);
    }
  }

  function closeSearch() {
    if (searchOverlay) {
      searchOverlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  document.querySelectorAll('[data-search-toggle]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      openSearch();
    });
  });

  if (searchCloseBtn) searchCloseBtn.addEventListener('click', closeSearch);

  /* --- Product card color swatches --- */
  document.addEventListener('click', function(e) {
    var swatch = e.target.closest('.product-card__swatch');
    if (!swatch) return;

    var card = swatch.closest('[data-product-card]');
    if (!card) return;

    // Update active state
    card.querySelectorAll('.product-card__swatch').forEach(function(s) {
      s.classList.remove('product-card__swatch--active');
    });
    swatch.classList.add('product-card__swatch--active');

    // Swap product image
    var newSrc = swatch.getAttribute('data-swatch-img');
    if (newSrc) {
      var img = card.querySelector('[data-card-img]');
      if (img) {
        img.style.opacity = '0';
        setTimeout(function() {
          img.src = newSrc;
          img.style.opacity = '1';
        }, 150);
      }
    }

    // Update product link to point to the correct variant
    var variantUrl = swatch.getAttribute('data-swatch-url');
    if (variantUrl) {
      var mediaLink = card.querySelector('[data-card-media]');
      if (mediaLink) mediaLink.setAttribute('href', variantUrl);
      var titleLink = card.querySelector('.product-card__title a');
      if (titleLink) titleLink.setAttribute('href', variantUrl);
    }
  });

  // Also swap on hover for a preview effect
  document.addEventListener('mouseenter', function(e) {
    if (!e.target.matches('.product-card__swatch')) return;

    var swatch = e.target;
    var card = swatch.closest('[data-product-card]');
    if (!card) return;

    var newSrc = swatch.getAttribute('data-swatch-img');
    if (newSrc) {
      var img = card.querySelector('[data-card-img]');
      if (img && img.src !== newSrc) {
        img.dataset.originalSrc = img.dataset.originalSrc || img.src;
        img.src = newSrc;
      }
    }
  }, true);

  document.addEventListener('mouseleave', function(e) {
    if (!e.target.matches('.product-card__swatch')) return;

    var swatch = e.target;
    // Only revert if this swatch is NOT the active one
    if (swatch.classList.contains('product-card__swatch--active')) return;

    var card = swatch.closest('[data-product-card]');
    if (!card) return;

    var img = card.querySelector('[data-card-img]');
    if (img && img.dataset.originalSrc) {
      // Revert to the active swatch's image or original
      var activeSwatch = card.querySelector('.product-card__swatch--active');
      if (activeSwatch && activeSwatch.getAttribute('data-swatch-img')) {
        img.src = activeSwatch.getAttribute('data-swatch-img');
      } else {
        img.src = img.dataset.originalSrc;
      }
    }
  }, true);

  /* --- Quantity selectors (delegated) --- */
  document.addEventListener('click', function(e) {
    var minusBtn = e.target.closest('[data-qty-minus]');
    var plusBtn = e.target.closest('[data-qty-plus]');

    if (minusBtn || plusBtn) {
      var wrapper = (minusBtn || plusBtn).closest('[data-qty-wrapper]');
      if (!wrapper) return;

      var input = wrapper.querySelector('input[type="number"], .cart-item__qty-value, .product-form__qty-input');
      if (!input) return;

      var val = parseInt(input.value || input.textContent) || 1;

      if (minusBtn && val > 1) val--;
      if (plusBtn) val++;

      if (input.tagName === 'INPUT') {
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        input.textContent = val;
      }
    }
  });

  /* --- Product variant selectors --- */
  document.addEventListener('click', function(e) {
    var optionBtn = e.target.closest('.product-option__value');
    if (!optionBtn || optionBtn.classList.contains('disabled')) return;

    // Toggle active state in this option group
    var group = optionBtn.closest('.product-option__values');
    if (group) {
      group.querySelectorAll('.product-option__value').forEach(function(b) {
        b.classList.remove('active');
      });
    }
    optionBtn.classList.add('active');

    // Update the hidden variant select based on all selected options
    updateVariantFromOptions();
  });

  function updateVariantFromOptions() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;

    var variantSelect = form.querySelector('select[name="id"]');
    if (!variantSelect) return;

    // Gather all selected option values
    var selectedOptions = [];
    form.querySelectorAll('.product-option').forEach(function(optionGroup) {
      var activeBtn = optionGroup.querySelector('.product-option__value.active');
      if (activeBtn) {
        selectedOptions.push(activeBtn.getAttribute('data-option-value'));
      }
    });

    // Find matching variant by comparing option values in the title
    var options = variantSelect.options;
    for (var i = 0; i < options.length; i++) {
      var optionTitle = options[i].textContent.trim().split(' \u2014 ')[0].trim();
      var optionValues = optionTitle.split(' / ').map(function(s) { return s.trim(); });

      var match = selectedOptions.length === optionValues.length &&
        selectedOptions.every(function(val, idx) {
          return val === optionValues[idx];
        });

      if (match) {
        variantSelect.value = options[i].value;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));

        // Update price display
        var priceText = options[i].textContent.trim().split(' \u2014 ')[1];
        if (priceText) {
          var priceEl = document.querySelector('.product-info__price span:first-child');
          if (priceEl) priceEl.textContent = priceText.trim();
        }

        // Update add-to-cart button state
        var addBtn = form.querySelector('[type="submit"]');
        if (addBtn) {
          if (options[i].disabled) {
            addBtn.disabled = true;
            addBtn.innerHTML = 'Sold Out';
          } else {
            addBtn.disabled = false;
            addBtn.innerHTML = '<i data-lucide="shopping-bag" style="width:18px;height:18px;"></i> Add to Cart';
            if (typeof lucide !== 'undefined') lucide.createIcons();
          }
        }
        break;
      }
    }
  }

  /* --- Product gallery thumbnails --- */
  document.querySelectorAll('.product-gallery__thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var gallery = this.closest('.product-gallery');
      if (!gallery) return;

      gallery.querySelectorAll('.product-gallery__thumb').forEach(function(t) {
        t.classList.remove('active');
      });
      this.classList.add('active');

      var mainImg = gallery.querySelector('.product-gallery__main img');
      var thumbImg = this.querySelector('img');
      if (!mainImg || !thumbImg) return;

      var newSrc = thumbImg.getAttribute('data-full') || thumbImg.src;
      mainImg.style.opacity = '0';
      mainImg.style.transition = 'opacity 0.2s ease';
      setTimeout(function() {
        mainImg.src = newSrc;
        mainImg.style.opacity = '1';
      }, 200);
    });
  });

  /* --- Accordion --- */
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('.product-accordion__trigger');
    if (!trigger) return;

    var content = trigger.nextElementSibling;
    if (!content) return;

    var isOpen = trigger.classList.contains('active');

    // Close all others in the same accordion
    var accordion = trigger.closest('.product-accordion');
    if (accordion) {
      accordion.querySelectorAll('.product-accordion__trigger').forEach(function(t) {
        t.classList.remove('active');
        t.setAttribute('aria-expanded', 'false');
        if (t.nextElementSibling) t.nextElementSibling.style.maxHeight = '0';
      });
    }

    if (!isOpen) {
      trigger.classList.add('active');
      trigger.setAttribute('aria-expanded', 'true');
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  });

  /* --- Scroll reveal animations --- */
  var revealElements = document.querySelectorAll('.reveal-on-scroll');
  if (revealElements.length > 0 && 'IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          revealObserver.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    revealElements.forEach(function(el) {
      revealObserver.observe(el);
    });
  } else {
    // Fallback: show everything immediately
    revealElements.forEach(function(el) {
      el.classList.add('revealed');
    });
  }

  /* --- Product image zoom on hover (desktop only) --- */
  if (window.matchMedia('(pointer: fine)').matches) {
    document.querySelectorAll('.product-gallery__main').forEach(function(main) {
      var img = main.querySelector('img');
      if (!img) return;

      main.addEventListener('mousemove', function(e) {
        var rect = main.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
        img.style.transform = 'scale(1.8)';
      });

      main.addEventListener('mouseleave', function() {
        img.style.transformOrigin = 'center center';
        img.style.transform = 'scale(1)';
      });
    });
  }

  /* --- Add to Cart AJAX --- */
  document.addEventListener('submit', function(e) {
    if (!e.target.matches('[data-product-form]')) return;
    e.preventDefault();

    var form = e.target;
    var btn = form.querySelector('[type="submit"]');
    if (btn && btn.disabled) return;

    var originalHTML = btn ? btn.innerHTML : '';

    if (btn) {
      btn.classList.add('btn--loading');
      btn.disabled = true;
    }

    // Build proper JSON body for Shopify
    var variantId = form.querySelector('[name="id"]').value;
    var qtyInput = form.querySelector('[name="quantity"]');
    var quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: quantity }),
    })
    .then(function(res) {
      if (!res.ok) {
        return res.json().then(function(err) { throw new Error(err.description || 'Could not add to cart'); });
      }
      return res.json();
    })
    .then(function(data) {
      if (btn) {
        btn.classList.remove('btn--loading');
        btn.innerHTML = '<i data-lucide="check" style="width:18px;height:18px;"></i> Added!';
        if (typeof lucide !== 'undefined') lucide.createIcons();
        setTimeout(function() {
          btn.innerHTML = originalHTML;
          btn.disabled = false;
          if (typeof lucide !== 'undefined') lucide.createIcons();
        }, 1500);
      }
      updateCartCount();
      openCart();
      refreshCartDrawer();
    })
    .catch(function(err) {
      console.error('Add to cart error:', err);
      if (btn) {
        btn.classList.remove('btn--loading');
        btn.innerHTML = err.message || 'Error';
        setTimeout(function() {
          btn.innerHTML = originalHTML;
          btn.disabled = false;
          if (typeof lucide !== 'undefined') lucide.createIcons();
        }, 2000);
      }
    });
  });

  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        document.querySelectorAll('.header__cart-count').forEach(function(el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
        // Update cart drawer title count
        var drawerTitle = document.querySelector('.cart-drawer__title');
        if (drawerTitle) {
          drawerTitle.textContent = 'Your Cart (' + cart.item_count + ')';
        }
      })
      .catch(function(err) {
        console.error('Cart count update error:', err);
      });
  }

  function refreshCartDrawer() {
    // Use Shopify Section Rendering API to fetch updated cart drawer
    fetch('/?section_id=cart-drawer', { headers: { 'Accept': 'text/html' } })
      .then(function(res) {
        if (!res.ok) throw new Error('Failed to fetch cart');
        return res.text();
      })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newItems = doc.querySelector('.cart-drawer__items');
        var newFooter = doc.querySelector('.cart-drawer__footer');
        if (newItems) {
          var currentItems = document.querySelector('.cart-drawer__items');
          if (currentItems) currentItems.innerHTML = newItems.innerHTML;
        }
        if (newFooter) {
          var currentFooter = document.querySelector('.cart-drawer__footer');
          if (currentFooter) currentFooter.innerHTML = newFooter.innerHTML;
        }
        // Re-initialize icons in the refreshed drawer
        if (typeof lucide !== 'undefined') lucide.createIcons();
      })
      .catch(function(err) {
        console.error('Cart drawer refresh error:', err);
      });
  }

  /* --- Collection page: sort --- */
  var sortSelect = document.querySelector('.collection-sort select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* ============================================================
     SHOPIFY MARKETS — Localization Selector Logic
     ============================================================ */
  (function initLocalization() {
    // Toggle dropdown open/close
    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('[data-localization-trigger]');

      if (trigger) {
        e.preventDefault();
        var selector = trigger.closest('[data-localization-dropdown]');
        if (!selector) return;

        var dropdown = selector.querySelector('.localization__dropdown');
        if (!dropdown) return;

        var isOpen = dropdown.classList.contains('active');

        // Close all other open dropdowns first
        document.querySelectorAll('.localization__dropdown.active').forEach(function(d) {
          d.classList.remove('active');
          var t = d.closest('[data-localization-dropdown]');
          if (t) {
            var btn = t.querySelector('[data-localization-trigger]');
            if (btn) btn.setAttribute('aria-expanded', 'false');
          }
        });

        if (!isOpen) {
          dropdown.classList.add('active');
          trigger.setAttribute('aria-expanded', 'true');
          // Focus search if present
          var search = dropdown.querySelector('[data-localization-search]');
          if (search) setTimeout(function() { search.focus(); }, 100);
        } else {
          trigger.setAttribute('aria-expanded', 'false');
        }
        return;
      }

      // Close on outside click
      if (!e.target.closest('[data-localization-dropdown]')) {
        document.querySelectorAll('.localization__dropdown.active').forEach(function(d) {
          d.classList.remove('active');
          var container = d.closest('[data-localization-dropdown]');
          if (container) {
            var btn = container.querySelector('[data-localization-trigger]');
            if (btn) btn.setAttribute('aria-expanded', 'false');
          }
        });
      }
    });

    // Search filter for country list
    document.querySelectorAll('[data-localization-search]').forEach(function(input) {
      input.addEventListener('input', function() {
        var query = this.value.toLowerCase().trim();
        var list = this.closest('.localization__dropdown').querySelector('[data-localization-list]');
        if (!list) return;

        list.querySelectorAll('.localization__option').forEach(function(option) {
          var name = option.getAttribute('data-country-name') || '';
          var currencyText = option.querySelector('.localization__option-currency');
          var currency = currencyText ? currencyText.textContent.toLowerCase() : '';

          if (name.indexOf(query) !== -1 || currency.indexOf(query) !== -1) {
            option.classList.remove('hidden');
          } else {
            option.classList.add('hidden');
          }
        });
      });
    });

    // Keyboard navigation: close on Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.localization__dropdown.active').forEach(function(d) {
          d.classList.remove('active');
          var container = d.closest('[data-localization-dropdown]');
          if (container) {
            var btn = container.querySelector('[data-localization-trigger]');
            if (btn) {
              btn.setAttribute('aria-expanded', 'false');
              btn.focus();
            }
          }
        });
      }
    });
  })();

  /* --- Initialize Lucide icons after DOM ready --- */
  document.addEventListener('DOMContentLoaded', function() {
    if (typeof lucide !== 'undefined') {
      lucide.createIcons();
    }
  });

})();
